import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "../../utils/utils"

const alertVariants = cva(
  "relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_minmax(0,1fr)] grid-cols-[0_minmax(0,1fr)] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive:
          "text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90",
        warning:
          "text-warning-foreground border-warning/50 bg-warning-muted [&>svg]:text-warning *:data-[slot=alert-description]:text-warning-foreground/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  )
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        className
      )}
      {...props}
    />
  )
}

function AlertDescription({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        // minmax(0,1fr) on the Alert + break-words here: a `1fr` track's
        // floor is its content's min-content, so one unbreakable token (an
        // error message carrying a URL or id) widened the column past the
        // alert and was clipped at 320px (/billing/payment-method).
        "text-muted-foreground col-start-2 grid min-w-0 justify-items-start gap-1 text-sm break-words [&_p]:leading-relaxed [&_p]:max-w-full",
        className
      )}
      {...props}
    />
  )
}

export { Alert, AlertDescription, AlertTitle }

